export default "__VITE_ASSET__DmiEe7U5__"